// Idle warning threshold in seconds (45 minutes)
export const IDLE_WARNING_THRESHOLD = 45 * 60; // 45 minutes in seconds
// Local storage key for clock sessions
export const CLOCK_SESSIONS_KEY = 'elink_clock_sessions';

